module.exports = __webpack_public_path__ + "img/couples-023.2b326ca6.jpg";